import { render, staticRenderFns } from "./damagesAftercare.vue?vue&type=template&id=6704a4b0&scoped=true"
import script from "./damagesAftercare.vue?vue&type=script&lang=js"
export * from "./damagesAftercare.vue?vue&type=script&lang=js"
import style0 from "./damagesAftercare.vue?vue&type=style&index=0&id=6704a4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704a4b0",
  null
  
)

export default component.exports